import eimg1 from '../images/resource/Z_Meghalaya.jpg'
import eimg2 from '../images/resource/Z_Arunachal.jpg'
import eimg3 from '../images/resource/SkillSwap.jpg'
import eimg4 from '../images/resource/BrainsBrews.jpg'


const Events = [
    {
        Id: '1',
        eTitle: 'Z_Megahalaya by Zentara ', 
        slug:'z_meghalaya',
        eImg:eimg1,
        day:'Recent',
        date:'What Happened',
        time:'Mawkdok Village, Meghalaya',
        speaker:'June 19, 2026',
        Icon:'flaticon-voice',
        des:'We’re inviting bold thinkers and changemakers from around the world to connect, reflect, explore wild ideas, embrace nature, share stories, and dive into epic experiences at Z_Meghalaya.',
        status:'comingSoon',
    },
    {
        Id: '2',
        eTitle: 'Z_Arunachal by Zentara', 
        slug:'z_arunachal',
        eImg:eimg2,
        day:'Recent',
        date:'What Happened',
        time:'Shergaon, Arunchal Pradesh',
        speaker:'November 22, 2025',
        Icon:'flaticon-voice',
        Sclass:'style-two',
        des:'We’re inviting bold thinkers and changemakers from around the world to connect, reflect, explore wild ideas, embrace nature, share stories, and dive into epic experiences at Z_Arunachal.',        status:'finished',    },
    {
        Id: '3',
        eTitle: 'Skill Swap Social', 
        slug:'skillswap',
        eImg:eimg3,
        day:'Upcoming',
        date:'What will Happen',
        time:'Zen Nest Rooftop, Guwahati',
        speaker:'August 10, 2025',
        Icon:'flaticon-voice',
        des:'SkillSwap Social is where real people share real skills, no boring lectures, just real conversations and hands-on learning. Come to learn, share, or just explore. You’ll leave with fresh ideas, new connections, and real growth.',        status:'finished',    },
    {
        Id: '4',
        eTitle: 'Brains and Brews 101', 
        slug:'brainsbrews',
        eImg:eimg4,
        day:'Upcoming',
        date:'What will Happen',
        time:'SHOTS Cafe and Bar, Guwahati',
        speaker:'June 22, 2025',
        Sclass:'style-two',
        Icon:'flaticon-voice',
        des:'Brains & Brews 101 is where ideas meet over a pint. No stiff suits, no heavy agendas, just lively conversations, fresh perspectives, and the perfect brew to spark them. Come to connect, exchange insights, or simply enjoy the vibe. You’ll leave with sharper thinking, new friends, and a taste of how networking can actually be fun.',        status:'finished',
        inviteLink:'https://forms.gle/yKPxTmVe2xcxaw4Z8',    },
    {
        Id: '5',
        eTitle: 'Brains and Brews 102', 
        slug:'brainsbrews',
        eImg:eimg4,
        day:'Upcoming',
        date:'What will Happen',
        time:'Georgies Retreat Eco Camp, Sonapur',
        speaker:'May 17, 2026',
        Sclass:'style-two',
        Icon:'flaticon-voice',
        des:'Brains & Brews 101 is A Hilltop Social for Founders, Creators & Curious Minds',
        status:'active',
        inviteLink:'https://forms.gle/yKPxTmVe2xcxaw4Z8',
    },
]

export default Events;